import * as i0 from '@angular/core';
import { RendererFactory2, Injectable, Inject, Directive, Input, HostListener, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';

const Styles = ` 

  .ng-tooltip {
    display: inline-block;
    position: absolute;
    text-decoration: none;
    border: 1px solid #ccc;
    max-width: 275px;
    font-size: 14px;
    text-align: center;
    color: #000;
    box-shadow: 0 5px 10px rgba(0,0,0,.2);
    padding: 10px 12px;
    background: #fff;
    border-radius: 6px;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.5s;
}
.ng-tooltip-show {
  opacity: 1;
}
/* creates a triangle pseudo-element for each tooltip according it's position, 
one before that will make the border, other right over it that matches the tooltip background color */
.ng-tooltip-top:before {
  top: 100%;
  left: 50%;
  margin-left: -10px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-top-color: #ccc;
}

.ng-tooltip-top:after {
  top: 99%;
  left: 50%;
  margin-left: -10px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-top-color:#fff;
}
.ng-tooltip-bottom:before{
  bottom: 100%;
  left: 50%;
  content: '';
  margin-left: -10px;
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-bottom-color: #ccc;
}
.ng-tooltip-bottom:after {
  bottom: 98%;
  left: 50%;
  content: '';  
  margin-left: -10px;
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-bottom-color: #fff;
}
.ng-tooltip-left:before {
  top: 50%;
  left: 100%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-left-color: #ccc;

}.ng-tooltip-left:after {
  top: 50%;
  left: 99%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-left-color: #fff;
}
.ng-tooltip-right:before {
  top: 50%;
  right: 100%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-right-color: #ccc;
}
.ng-tooltip-right:after {
  top: 50%;
  right: 99%;
  margin-top: -10px;
  border-width: 6px;
  content: '';
  display: block;  
  position: absolute;
  border: 9px solid transparent;
  border-right-color: #fff;
}
`;

//this code below is related to the tooltip css style added by injection
const STYLE = Styles;
class DirectiveStylesService {
    constructor(documentRef, rendererFactory) {
        this.documentRef = documentRef;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    addStyle(styles, attribute) {
        if (this.documentRef.head.querySelector(`style[${attribute}]`)) {
            return;
        }
        const style = this.renderer.createElement('style');
        this.renderer.setProperty(style, 'textContent', styles);
        this.renderer.setAttribute(style, attribute, '');
        this.documentRef.head.appendChild(style);
    }
}
DirectiveStylesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectiveStylesService, deps: [{ token: DOCUMENT }, { token: RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
DirectiveStylesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectiveStylesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: DirectiveStylesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: Document, decorators: [{
                        type: Inject,
                        args: [DOCUMENT]
                    }] }, { type: i0.RendererFactory2, decorators: [{
                        type: Inject,
                        args: [RendererFactory2]
                    }] }];
    } });
class TooltipDirective {
    constructor(el, renderer, directiveStyles) {
        this.el = el;
        this.renderer = renderer;
        this.offset = 10; // distance between host element and tooltip element
        directiveStyles.addStyle(STYLE, 'psUiTooltip');
    }
    onMouseEnter() {
        if (!this.tooltip) {
            this.show();
        }
    }
    onMouseLeave() {
        if (this.tooltip) {
            this.hide();
        }
    }
    show() {
        this.create();
        this.setPosition();
        this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
    }
    hide() {
        this.renderer.removeClass(this.tooltip, 'ng-tooltip-show');
        window.setTimeout(() => {
            if (this.tooltip) {
                this.renderer.removeChild(document.body, this.tooltip);
                this.tooltip = null;
            }
        }, 500);
    }
    create() {
        this.tooltip = this.renderer.createElement('span');
        this.renderer.appendChild(this.tooltip, this.renderer.createText(this.title));
        this.renderer.appendChild(document.body, this.tooltip);
        this.renderer.addClass(this.tooltip, 'ng-tooltip');
        this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
    }
    setPosition() {
        // gets the host and tooltip size and location
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos = this.tooltip.getBoundingClientRect();
        // returns the relative position in the viewport.
        //When scrolling, the vertical scroll value should be reflected on the top of the tooltip element.
        const scrollPos = window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        let top, left;
        if (this.placement === 'top') {
            top = hostPos.top - tooltipPos.height - this.offset;
            left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        }
        if (this.placement === 'bottom') {
            top = hostPos.bottom + this.offset;
            left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
        }
        if (this.placement === 'left') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = hostPos.left - tooltipPos.width - this.offset;
        }
        if (this.placement === 'right') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = hostPos.right + this.offset;
        }
        this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
    }
}
TooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: DirectiveStylesService }], target: i0.ɵɵFactoryTarget.Directive });
TooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.12", type: TooltipDirective, selector: "[psUiTooltip]", inputs: { title: ["psUiTooltip", "title"], placement: "placement" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[psUiTooltip]',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: DirectiveStylesService, decorators: [{
                        type: Inject,
                        args: [DirectiveStylesService]
                    }] }];
    }, propDecorators: { title: [{
                type: Input,
                args: ['psUiTooltip']
            }], placement: [{
                type: Input
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class TooltipModule {
}
TooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipModule, declarations: [TooltipDirective], imports: [CommonModule], exports: [TooltipDirective] });
TooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: TooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TooltipDirective],
                    exports: [TooltipDirective],
                    imports: [CommonModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipDirective, TooltipModule };
